import React from 'react';

/**
 * Skeleton primitives — shimmer placeholders that match the final layout.
 * Use instead of Bootstrap <Spinner /> on list/card pages to improve perceived performance.
 *
 * <SkeletonLine width="60%" />              — single text line
 * <SkeletonBlock height={120} />            — generic block
 * <SkeletonCard />                          — exhibition-card placeholder
 * <SkeletonListItem />                      — exhibitor/exhibit row placeholder
 * <SkeletonGrid count={6} />                — grid of 6 cards
 * <SkeletonList count={8} />                — list of 8 rows
 */

export const SkeletonLine = ({ width = '100%', height = 12, className = '', style }) => (
  <span
    className={`skeleton-shimmer ${className}`}
    style={{
      display: 'block',
      width,
      height,
      borderRadius: 'var(--app-radius-xs)',
      ...style,
    }}
  />
);

export const SkeletonBlock = ({ width = '100%', height = 120, radius = 'var(--app-radius-md)', className = '', style }) => (
  <div
    className={`skeleton-shimmer ${className}`}
    style={{
      width,
      height,
      borderRadius: radius,
      ...style,
    }}
  />
);

export const SkeletonCard = () => (
  <div className="skeleton-card">
    <SkeletonBlock height={180} radius="0" className="skeleton-card-img" />
    <div className="skeleton-card-body">
      <SkeletonLine width="80%" height={18} />
      <SkeletonLine width="55%" height={12} style={{ marginTop: 10 }} />
    </div>
  </div>
);

export const SkeletonListItem = () => (
  <div className="skeleton-list-item">
    <div className="skeleton-list-avatar skeleton-shimmer" />
    <div style={{ flex: 1, minWidth: 0 }}>
      <SkeletonLine width="65%" height={14} />
      <SkeletonLine width="40%" height={11} style={{ marginTop: 8 }} />
    </div>
  </div>
);

export const SkeletonGrid = ({ count = 6 }) => (
  <div className="skeleton-grid">
    {Array.from({ length: count }, (_, i) => (
      <SkeletonCard key={i} />
    ))}
  </div>
);

export const SkeletonList = ({ count = 8 }) => (
  <div className="skeleton-list">
    {Array.from({ length: count }, (_, i) => (
      <SkeletonListItem key={i} />
    ))}
  </div>
);
